// eslint-disable-next-line import/no-unresolved
const baseProductBase = require('base/product/base');
const constants = require('../constants');
const quickviewSlider = require('../components/slider');
const utils = require('../utils');

// This file contains all logic in common between the grid
// and the PDP as extended core functions or methods.
// This will be imported by baseDetail, baseGrid and possibly
// other files (lightening the load compared to the classic base.js).

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.choice-of-bonus-product');
    const footer = $html.find('.modal-footer').children();

    return { body, footer };
}

function chooseBonusProducts(data) {
    $('.modal-body')
        .spinner()
        .start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    let bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    const htmlString = `${'<!-- Modal -->'
            + '<div class="modal fade" id="chooseBonusProductModal" role="dialog">'
            + '<div class="modal-dialog choose-bonus-product-dialog big" '
            + 'data-total-qty="'}${data.maxBonusItems}"`
        + `data-UUID="${data.uuid}"`
        + `data-pliUUID="${data.pliUUID}"`
        + `data-addToCartUrl="${data.addToCartUrl}"`
        + 'data-pageStart="0"'
        + `data-pageSize="${data.pageSize}"`
        + `data-moreURL="${data.showProductsUrlRuleBased}"`
        + `data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">`
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + `    <span class="heading2">${data.labels.selectprods}</span>`
        + '    <button type="button" class="close no-btn icon-cross-line" data-dismiss="modal" mcclane-data="close-generic-popup"></button>'
        + '</div>'
        + '<div class="modal-body"><div class="row"></div></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body')
        .spinner()
        .start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: (response) => {
            const parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body .row').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body .row').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);

            // $('.selected-bonus-products .bonus-summary .samples-select-zero').show();

            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        },
    });
}

const addToCartModalCarousel = () => {
    const { prev, next } = utils.getSliderLabels();
    const runSlick = (element) => {
        quickviewSlider.methods.useCustomizableSlick(
            element,
            true,
            `<button type="button" class="icon-left-arrow-line next no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line prev no-btn" aria-label="${next}"></button>`,
            4,
            {
                dots: false,
                arrows: true,
                infinite: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: constants.viewport_bootstrap.md,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: true,
                            dots: false,
                        },
                    },
                    {
                        breakpoint: constants.viewport_bootstrap.lg,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            arrows: true,
                            dots: false,
                        },
                    },
                ],
            },
        );
    };

    // eslint-disable-next-line consistent-return
    const checkElement = (selector, fn) => {
        if ($(selector).length) {
            fn();
            return;
        }
        setTimeout(() => {
            checkElement(selector, fn);
        }, 100);
    };

    const slickConfig = () => {
        checkElement('.recomendations-content .product-carousel .product', runSlick.bind(null, '.recomendations-content .product-carousel'));
    };

    slickConfig();
};

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart-quantity').trigger('count:update', response);
    const messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.addtocarttemplate && !response.error && window.outerWidth >= constants.viewport_bootstrap.lgs) {
        const docBody = $(document.body);
        const addToCartModal = $('#addtocart-modal');
        addToCartModal.empty().append(response.addtocarttemplate);
        addToCartModal.find('.product-addtocard-message').append(response.message);
        docBody.append(addToCartModal);
        const modalContent = addToCartModal.find('.modal-dialog');
        addToCartModal.modal('show');
        modalContent.toggleClass('active');

        addToCartModal.off('shown.bs.modal').on('shown.bs.modal', () => {
            addToCartModalCarousel();
        });

        addToCartModal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
            if ($('#addtocart-modal.modal').length > 1) {
                $('body > #addtocart-modal').remove();
            }
        });

        docBody.find('.continue-shopping-button').on('click', (e) => {
            e.preventDefault();
            addToCartModal.modal('hide');
            modalContent.toggleClass('active');
        });
    } else if (
        response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0
    ) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        let messageIcon;

        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        if (!response.error) {
            messageIcon = '<span class="icon-checked-line"></span>';
        } else {
            messageIcon = '<span class="icon-alert"></span>';
        }

        $('.add-to-cart-messages').append(
            `<div class="alert ${messageType} add-to-basket-alert text-center" role="alert">${messageIcon} ${
                response.message
            }</div>`,
        );

        setTimeout(() => {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    const options = $productContainer
        .find('.product-option')
        // eslint-disable-next-line func-names
        .map(function () {
            const $elOption = $(this).find('.options-select');
            const urlValue = $elOption.val();
            const selectedValueId = $elOption.find(`option[value="${urlValue}"]`).data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId,
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    const childProducts = [];
    // eslint-disable-next-line func-names
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).data('pid'),
            quantity: parseInt(
                $(this)
                    .find('.quantity')
                    .data('quantity'),
                10,
            ),
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

const getSwhatchables = (swatchablesToCheck) => {
    const swatchableTypes = [];

    swatchablesToCheck
        .each((_indx, elem) => {
            const $elem = $(elem);
            const divAttr = $elem.parents('.attribute-wrapper').length
                ? $elem.parents('.attribute-wrapper').data('attr')
                : $elem.data('attr');

            const variationType = !divAttr ? '' : divAttr.toLowerCase();

            if (!swatchableTypes.some(item => item === variationType) && variationType.length) {
                swatchableTypes.push(variationType);
            }
        });

    return swatchableTypes;
};

baseProductBase.methods.editBonusProducts = (data) => {
    chooseBonusProducts(data);
};

module.exports = {
    ...baseProductBase,
    methods: {
        getAddToCartUrl,
        getOptions,
        getChildProducts,
        handlePostCartAdd,
        getSwhatchables,
    },
};
